// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_4y-0";
export var orangeButton = "_4y-1";